import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { buildUserFromToken, storeAuthFromToken } from "../utils/auth";

export default function ForceResetPage({ onAuth }) {
  const navigate = useNavigate();
  const coreUrl =
    process.env.REACT_APP_CORE_IDENTITY_URL ||
    "https://masterdashboard.xpresspaper.eu";
  const resetToken = useMemo(() => localStorage.getItem("resetToken"), []);

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!resetToken) {
      setError("Reset session expired. Please sign in again.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    if (password === "123456") {
      setError("Please choose a different password.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${coreUrl}/auth/force-reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${resetToken}`,
        },
        body: JSON.stringify({ newPassword: password }),
      });
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || "Password reset failed");
      }
      const data = await res.json();
      const nextToken = data.token || resetToken;
      localStorage.removeItem("resetToken");

      const tokenUser = storeAuthFromToken(nextToken) || buildUserFromToken(nextToken);
      if (tokenUser) {
        localStorage.setItem("user", JSON.stringify(tokenUser));
        if (onAuth) onAuth(tokenUser);
      }
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err.message || "Password reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bgLight">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-8 w-full max-w-md space-y-4">
        <h1 className="text-2xl font-bold text-navy text-center">
          Reset Your Password
        </h1>
        <p className="text-sm text-slate-600 text-center">
          For security, please replace your default password.
        </p>
        {error && (
          <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            {error}
          </div>
        )}
        {!resetToken ? (
          <button
            type="button"
            onClick={() => navigate("/sso")}
            className="w-full inline-flex items-center justify-center px-4 py-2 rounded-lg bg-navy text-white text-sm font-semibold shadow-sm hover:bg-navy/90"
          >
            Go to Login
          </button>
        ) : (
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-slate-800 mb-1">
              New Password
            </label>
            <input
              type="password"
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gold/70 focus:border-gold/70"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-800 mb-1">
              Confirm Password
            </label>
            <input
              type="password"
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gold/70 focus:border-gold/70"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center px-4 py-2 rounded-lg bg-navy text-white text-sm font-semibold shadow-sm hover:bg-navy/90 disabled:opacity-60"
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
        )}
      </div>
    </div>
  );
}
